<template>
    <div class="form__subsection">
        <h3>Familiemedlemmer:</h3>
        <ul v-if="members.length" class="mypage-profile__action-list">
            <li v-for="member in members" :key="member.id" class="mypage-profile__action-row">
                <span class="mypage-profile__member-name">
                    <span class="mypage-profile__member-icon">
                        <i class="pi pi-user" aria-hidden="true"></i>
                    </span>
                    <FamilyMemberModal
                        mode="edit"
                        :member="member"
                        :csrf-token="csrfToken"
                        :trigger-label="`${member.Navn} ${member.Etternavn}`"
                        trigger-class="hover-underline"
                        @saved="onSaved"
                        @converted="onRemoved"
                        @deleted="onRemoved"
                    />
                </span>
            </li>
        </ul>
        <FamilyMemberModal
            mode="create"
            :csrf-token="csrfToken"
            trigger-label="+ Legg til familiemedlem"
            @saved="onSaved"
        />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import FamilyMemberModal from './FamilyMemberModal.vue';

const props = defineProps({
    csrfToken: { type: String, required: true },
});

const members = ref([]);

onMounted(async () => {
    try {
        const response = await fetch('/xhr/frontend/family', {
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            return;
        }
        const data = await response.json();
        members.value = data.members || [];
    } catch (e) {
        // Leave the list empty - the "+ Legg til familiemedlem" trigger still works.
    }
});

function onSaved(member) {
    const index = members.value.findIndex((m) => m.id === member.id);
    if (index === -1) {
        members.value.push(member);
    } else {
        members.value[index] = member;
    }
}

// Shared by both @converted and @deleted - either way the member is no
// longer part of the current user's family list.
function onRemoved(memberId) {
    members.value = members.value.filter((m) => m.id !== memberId);
}
</script>
